/** The Spawnwire mark: a white S split in two, on green. Same artwork as public/favicon.svg. */
export function LogoMark({ size = 32, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" className={className} aria-hidden>
      <rect width="100" height="100" rx="28" fill="#19b955" />
      <path
        fill="#fff"
        d="M59.24 18.50Q57.63 17.53 55.98 18.43L26.82 34.38C18.90 38.49 17.60 50.68 24.65 54.70L37.01 61.66Q38.39 62.44 39.76 61.63L50.19 55.44Q51.55 54.63 50.18 53.82L36.14 45.53Q35.14 44.94 36.14 44.35L67.62 25.79Q69.49 24.69 67.63 23.57Z"
      />
      <path
        fill="#fff"
        d="M40.76 81.50Q42.37 82.47 44.02 81.57L73.18 65.62C81.10 61.51 82.40 49.32 75.35 45.30L62.99 38.34Q61.61 37.56 60.24 38.37L49.81 44.56Q48.45 45.37 49.82 46.18L63.86 54.47Q64.86 55.06 63.86 55.65L32.38 74.21Q30.51 75.31 32.37 76.43Z"
      />
    </svg>
  );
}

export function Wordmark() {
  return (
    <span className="inline-flex items-center gap-2.5">
      <LogoMark size={36} />
      <span className="text-2xl font-bold tracking-tight text-fg">spawnwire</span>
    </span>
  );
}
